<div
  class="similar-inquiries-md-head"
  (click)="toggle()"
>
  <span class="similar-inquiries-md-head-text">{{ 'inquiry.similarInquiries' | translate }}</span>
  <i
    class="fa-solid fa-fw"
    [ngClass]="isExpanded ? 'fa-chevron-down' : 'fa-chevron-up'"
  ></i>
</div>

<div
  class="similar-inquiries-md-body"
  *ngIf="similarInquiries.length; else emptyList"
>
  <base-customer-similar-inquiries-md-calendar></base-customer-similar-inquiries-md-calendar>
  <div class="similar-inquiries-md-items">
    <base-customer-similar-inquiries-md-inquiry
      *ngFor="let inquiry of similarInquiries; trackBy: trackByInquiry"
      [inquiry]="inquiry"
    ></base-customer-similar-inquiries-md-inquiry>
  </div>
</div>

<ng-template #emptyList>
  <base-empty-list-row
    [backgroundSecondary]="true"
    [hideBackgroundImage]="true"
    message="inquiry.emptySimilarInquiriesList"
  ></base-empty-list-row>
</ng-template>
